<ion-content class="ion-no-padding">
  <form class="model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">Voucher View <span *ngIf="voucherId">({{voucherId}})</span> for {{leadDetails?.firstName}} {{leadDetails?.lastName}}</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">

          <ion-button class="filled-blue-btn" (click)="editVoucher()">
            Edit
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="openDownloadPopover($event)">
            Download
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="sendVoucher($event)">
            Send
          </ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content" >
      <div  id="print-voucher-section" class="voucher-data-html d-flex justify-content-center" [innerHTML]="VoucherDataHtml">
        <!-- Putting rendered html data here -->
      </div>
    </div>

  </form>
</ion-content>



<!-- ---------------------- -->
  